module.exports = "<div class=\"app-preview-container\" [style.left]=\"left + 'px'\" (mouseenter)=\"disablePageScroll()\" (mouseleave)=\"enablePageScroll()\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/app-preview-container/app-preview-container.component.html
// module id = ../../../../../src/app/shared/components/app-preview-container/app-preview-container.component.html
// module chunks = 12